import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
// 	// <HelmetProvider>
// 	<App />
// 	// </HelmetProvider>
// );

const container = document.getElementById('root');
let root;

// React 18에서는 createRoot와 hydrateRoot를 사용합니다.
if (container.hasChildNodes()) {
	// 서버 사이드 렌더링된 콘텐츠가 있는 경우, hydrateRoot를 사용
	root = ReactDOM.hydrateRoot(
		container,
		<HelmetProvider>
			<App />
		</HelmetProvider>
	);
} else {
	// 클라이언트 사이드에서 처음 렌더링할 경우, createRoot를 사용
	root = ReactDOM.createRoot(container);
	root.render(
		<HelmetProvider>
			<App />
		</HelmetProvider>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
